export function SHOW_SPINNER() {
  return (Class: any) => {
    Object.defineProperty(Class.prototype, 'showSpinner', {
      value: true,
    });
  };
}
